module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_engl_sekundærlogo_sentrert_logo_pos.ebc202ab.pdf";